import { Component } from "@angular/core";
import { AuthService } from "@app/auth/services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { BroadcastService } from "@app/shared/services/broadcast.service";

@Component({
  selector: "app-registration",
  templateUrl: "./verify.component.html",
  styleUrls: ["./verify.component.scss"],
})
export class VerifyComponent {
  MINIMUM_PASSWORD_LENGTH = 8;
  passwordForm: FormGroup;
  showPassword: boolean = false;
  loading: boolean = false;
  verified: boolean = false;
  registrationSuccess = false;
  moreInfo: boolean = true;
  emailSent: boolean = false;

  error: string = "";
  registrationToken: string;
  passwordReset: boolean;
  userRegistration: boolean;

  constructor(
      private authService: AuthService,
      private route: ActivatedRoute,
      private router: Router,
      private formBuilder: FormBuilder,
      private broadcastService: BroadcastService,
  ) {}

  ngOnInit() {
    const { registrationToken, method } = this.route.snapshot.params;
    this.registrationToken = registrationToken;
    this.userRegistration = method == "registration"
    this.passwordReset = (method == "reset_password") || this.userRegistration;
    if (!this.passwordReset) {
      this.verifyRegistration();
    } else {
      this.createForm();
    }
  }

  createForm(): void {
    const password = "";
    this.passwordForm = this.formBuilder.group({
      password: [password, [Validators.required, Validators.minLength(this.MINIMUM_PASSWORD_LENGTH)]]
    });
  }

  get password() {
    return this.passwordForm.get("password");
  }

  onSubmit() {
    this.loading = true;
    this.error = "";
    if (!this.passwordForm.valid) {
      return;
    }

    if (this.passwordReset || this.userRegistration) {
      this.resetPassword();
    } else {
      this.verifyRegistration();
    }
  }

  verifyRegistration(): void {
    this.loading = true;
    this.authService
        .verifyRegistration(this.registrationToken)
        .subscribe((response) => {
          if (response.ok) {
            this.broadcastService.publish({ type: "emailVerification", payload: { verified: true }});
            setTimeout(() => {
              this.loading = false;
              this.verified = true;
            }, 1000);
          } else {
            this.error = response.error?.error || "An unexpected error has occurred.";
            this.loading = false;
          }
        });
  }

  resetPassword(): void {
    this.authService
        .resetPassword(this.registrationToken, this.password.value, this.password.value)
        .subscribe((response) => {
          if (response.ok) {
            setTimeout(() => {
              window.location.href = '/dashboard';
            }, 1000);
          } else {
            this.error = response.error?.error || "An unexpected error has occurred.";
            this.loading = false;
          }
        });
  }

  goToDash(): void {
    window.location.href = '/dashboard';
  }

  changeEmail() {
    this.registrationSuccess = false;
    this.moreInfo = true;
    this.emailSent = false;
  }

  resendEmail() {
    this.emailSent = true;
    this.onSubmit();
  }
}
